import * as Sentry from '@sentry/vue'
import { isAxiosError } from 'axios'

import type { Plugin } from 'vue'

const sentryVuePlugin: Plugin<{
  tags?: Record<string, string>
}> = {
  install: (app, options) => {
    Sentry.init({
      enabled: import.meta.env.VITE_SENTRY_VUE_ENABLED === 'true',
      app,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      dsn: import.meta.env.VITE_SENTRY_VUE_DSN ?? '',
      tracesSampleRate: Number.parseFloat(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        import.meta.env.VITE_SENTRY_VUE_TRACES_SAMPLE_RATE ?? '0.0',
      ),

      logErrors: true,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? 'failed',

      replaysSessionSampleRate: Number.parseFloat(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        import.meta.env.VITE_SENTRY_VUE_REPLAYS_SESSION_SAMPLE_RATE ?? '0.0',
      ),
      replaysOnErrorSampleRate: Number.parseFloat(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        import.meta.env.VITE_SENTRY_VUE_REPLAYS_ON_ERROR_SAMPLE_RATE ?? '1.0',
      ),

      timeout: 500,
      trackComponents: true,

      integrations: [new Sentry.Replay(), new Sentry.BrowserTracing()],
      beforeSend(event, hint) {
        const error = hint.originalException
        if (error && isAxiosError(error) && error.message === 'Network Error') {
          return null
        }
        return event
      }
    })

    if (options.tags) {
      Sentry.setTags(options.tags)
    }
  },
}

export default sentryVuePlugin
